// app/components/Header/components/NewWidgetButton.tsx:
'use client'

export function NewWidgetButton() {
  return (
    <span
      onClick={() => {
        window.dispatchEvent(new Event('open-widget-drawer'))
      }}
      className="text-gray-700 hover:underline cursor-pointer"
      style={{ borderRadius: 0, padding: '4px' }}
      data-tutorial="new-widget-button"
    >
      <span className="flex" style={{ color: '#21728d' }}>
        New Widget
      </span>
    </span>
  )
}
